const base = {
  flex: '0 1 100%',
  maxWidth: '100%'
};

const chart = {
  default: {
    ...base,
    backgroundColor: 'indigo.100'
  },
  inverse: {
    ...base,
    backgroundColor: 'indigo.100',
    color: 'white'
  },
  transparent: {
    ...base,
    background: 'transparent'
  }
};

const co = {
  default: {
    ...base,
    backgroundColor: 'indigo.100'
  },
  inverse: {
    ...base,
    backgroundColor: 'indigo.100',
    color: 'white'
  },
  transparent: {
    ...base,
    background: 'transparent'
  }
};

const edu = {
  default: {
    ...base,
    backgroundColor: 'indigo.100'
  },
  inverse: {
    ...base,
    backgroundColor: 'indigo.100',
    color: 'white'
  },
  transparent: {
    ...base,
    background: 'transparent'
  }
};

const press = {
  default: {
    ...base,
    backgroundColor: 'indigo.100'
  },
  inverse: {
    ...base,
    backgroundColor: 'indigo.100',
    color: 'white'
  },
  transparent: {
    ...base,
    background: 'transparent'
  }
};

const spark = {
  default: {
    ...base,
    backgroundColor: 'indigo.90'
  },
  inverse: {
    ...base,
    backgroundColor: 'indigo.90',
    color: 'white'
  },
  transparent: {
    ...base,
    background: 'transparent'
  }
};

const panel = {
  products: {
    chart,
    co,
    edu,
    press,
    spark
  }
};

export const panelVariants = Object.keys(chart);

export type PanelType = 'default' | 'inverse' | 'transparent';

export default panel;
